import { gql } from '@apollo/client';

export const SET_SOCIAL_MEDIA_INTEGRATION_SETTINGS = gql`
  mutation SetSocialMediaIntegrationSettings(
    $input: SetSocialMediaIntegrationSettingsInput!
  ) {
    setSocialMediaIntegrationSettings(input: $input) {
      id
      allowedUsers {
        id
        firstName
        lastName
        storeDetails {
          storeName
        }
      }
      ... on SocialMediaIntegrationNewFlowSettings {
        isEnabled
      }
    }
  }
`;

export const SET_CB_SOCIAL_MEDIA_FLOW_SETTINGS = gql`
  mutation SetCbSocialMediaFlowSettings(
    $input: SetSocialMediaIntegrationSettingsInput!
  ) {
    setCbSocialMediaFlowSettings(input: $input) {
      id
      allowedUsers {
        id
        firstName
        lastName
        storeDetails {
          storeName
        }
      }
      isEnabled
    }
  }
`;
